import React, {PureComponent} from 'react'
import cn from "classnames"
import injectSheet from 'react-jss'
import theme from "../../styles/theme"

class Label extends PureComponent {
    render() {
        const {classes, className, text} = this.props;
        return <div className={cn(classes.root, className)}><span dangerouslySetInnerHTML={{__html: text}}></span></div>
    }
}

export default injectSheet({
    root: {
        ...theme.font.label,
    }
})(Label)





// WEBPACK FOOTER //
// ./src/components/Widgets/Label.js